export default {
    "You can select up to {count} options": "Μπορείτε να επιλέξετε έως {count} επιλογές",
    "Please answer all required questions to continue": "Παρακαλούμε απαντήστε σε όλες τις υποχρεωτικές ερωτήσεις για να συνεχίσετε",
    "Delete selected": "Διαγραφή επιλεγμένων",
    "passwords": "κωδικοί",
    "Deleted successfully": "Διαγράφηκε επιτυχώς",
    "Delete": "Διαγραφή",
    "Generate": "Δημιουργία",
    "Next Section": "Επόμενη ενότητα",
    "Previous Section": "Προηγούμενη ενότητα",
    "Next Question": "Επόμενη ερώτηση",
    "Previous Question": "Προηγούμενη ερώτηση",
    "Complete": "Ολοκλήρωση",
    "Inactive": "Ανενεργό",
    "Survey duplicated successfully": "Το ερωτηματολόγιο αντιγράφηκε επιτυχώς",
    "Duplicate this survey?": "Δημιουργία αντιγράφου του ερωτηματολογίου;",
    "Duplicate": "Αντίγραφο",
    "Emails sent: ": "Στάλθηκαν emails: ",
    "Please select at least one email": "Επιλέξτε τουλάχιστον ένα email",
    "Not sent": "Δεν στάλθηκε",
    "Not answered": "Δεν απαντήθηκε",
    "Response Date": "Ημ/νία απάντησης",
    "Sent Date": "Ημ/νία αποστολής",
    "Resend to Selected": "Αποστολή στα επιλεγμένα",
    "Clear Selection": "Καθαρισμός επιλογής",
    "Select All Filtered (Not Answered)": "Επιλογή όλων (Δεν απάντησαν)",
    "Selected": "Επιλεγμένα",
    "Not yet answered": "Δεν απάντησαν ακόμα",
    "Filtered": "Φιλτραρίστηκαν",
    "Clear Filters": "Καθαρισμός φίλτρων",
    "email contains...": "το email περιέχει...",
    "Search by email": "Αναζήτηση με email",
    "To Date": "Έως ημερομηνία",
    "From Date": "Από ημερομηνία",

    "* Please choose more options.": "* Επιλέξτε περισσότερες επιλογές.",
    "1. Download application in your local drive": "1. Κατεβάστε την εφαρμογή στον υπολογιστή σας",
    "2. Go to email list edit page and copy ID of email list": "2. Μεταβείτε στη σελίδα επεξεργασίας λίστας email και αντιγράψτε το αναγνωριστικό της λίστας email",
    "3. Open downloaded application": "3. Ανοίξτε την εφαρμογή που κατεβάσατε",
    "4. Select directory where you saved csv files": "4. Επιλέξτε τον φάκελο όπου αποθηκεύτε τα αρχεία csv",
    "400 Invalid input!": "400 Μη έγκυρη εισαγωγή!",
    "404 Not found!": "404 δεν βρέθηκε!",
    "5. Enter email list ID you copied in step 2": "5. Εισαγάγετε το αναγνωριστικό λίστας email που αντιγράψατε στο βήμα 2",
    "500 Server error!": "500 Σφάλμα Διακομιστή!",
    "Your session has expired. Please sign in again.": "Η σύνδεσή σας έληξε. Παρακαλούμε συνδεθείτε ξανά.",
    "6. Click start button": "6. Κάντε κλικ στο κουμπί START",
    "Actions": "Ενέργειες",
    "Actions": "Ενέργειες",
    "Activate": "Ενέργοποιημένο",
    "Activate failed": "Η ενεργοποίηση απέτυχε",
    "Activate success": "Επιτυχημένη ενεργοποίηση",
    "Active": "Ενεργό",
    "Activity": "Δραστηριότητα",
    "Add": "Προσθήκη",
    "Add New": "Προσθεσε νεο",
    "Add new email in list": "Προσθήκη νέου email στη λίστα",
    "Add New End Message": "Προσθήκη νέου μηνύματος τέλους",
    "Add New Question": "Προσθήκη νέας ερώτησης",
    "Add passwords": "Προσθήκη κωδικών πρόσβασης",
    "Add Question": "Προσθήκη ερώτησης",
    "Add to costumers": "Προσθήκη στους πελάτες",
    "Add your question in section": "Προσθέστε την ερώτησή σας στην ενότητα",
    "Additional Emails": "Πρόσθετα email",
    "All": "Ολα",
    "Allotment Survey": "Προσχέδια Ερωτηματολογίων",
    "ALLOTMENT SURVEYS": "ΕΤΟΙΜΑ ΕΡΩΤΗΜΑΤΟΛΟΓΙΑ",
    "Already existing from~to range": "Υπάρχει ήδη από ~ έως εύρος",
    "Amount": "Ποσό",
    "An Error occured with your payment": "Παρουσιάστηκε σφάλμα με την πληρωμή σας",
    "Analytical": "Αναλυτικά",
    "Answer": "Απαντήσεις",
    "Answer By Adding Email": "Απαντήσεις με απαίτηση του email",
    "Answer by ID free choice": "Room number | Αριθμός δωματίου | Zimmernummer",
    "Answer Type Choose, one of the options bellow how you need to protect you Survey.": "Τύπος Απάντησης - Επιλέξτε, μία από τις παρακάτω επιλογές, πώς θα θέλατε να προστατεύσετε τα ερωτηματολόγιά σας",
    "Answers": "Απαντήσεις",
    "API key": "Κλειδί API",
    "Are you sure?": "Είσαι σίγουρος?",
    "Attempted": "ΑΠΑΝΤΗΘΗΚΕ",
    "Authentication token is invalid": "Το διακριτικό ελέγχου ταυτότητας δεν είναι έγκυρο",
    "Automatic": "Αυτόματο",
    "Back": "Πίσω",
    "Buy more answers": "Αγοράστε περισσότερες απαντήσεις",
    "Campaign": "Καμπάνια",
    "Campaign Detail": "Λεπτομέρειες καμπάνιας",
    "Campaign name": "Όνομα καμπάνιας",
    "Cancel": "Άκυρο",
    "Change": "Αλλαγή",
    "Change Password": "Αλλαγή κωδικού",
    "CHOICES": "ΕΠΙΛΟΓΗ",
    "Choose": "Επιλέγω",
    "Choose Answers Type": "Επιλέξτε Τύπο απαντήσεων",
    "Choose costomers for allotment": "Επιλέξτε πελάτες για κατανομή",
    "Choose date": "Επιλέξτε ημερομηνία",
    "Choose groups(contact):": "Επιλέξτε ομάδες (επικοινωνίας):",
    "Choose Language": "Διάλεξε γλώσσα",
    "Choose option:": "Επιλέξτε :",
    "Choose Period 2th*:": "Επιλέξτε 2η Περίοδο* :",
    "Choose Position for Answers": "Επιλέξτε Θέση για Απαντήσεις",
    "Choose question:": "Επιλέξτε ερώτηση:",
    "Choose section:": "Επιλέξτε ενότητα:",
    "Choose Type of Answer": "Επιλέξτε Τύπο Απάντησης",
    "City": "Πόλη",
    "Close": "Κλείσε",
    "Company Address": "Διεύθυνση εταιρίας",
    "Company Name": "Όνομα εταιρείας",
    "Company Name": "Όνομα εταιρείας",
    "Company Tax Number": "ΑΦΜ",
    "Company Tax Office": "ΔOY",
    "Comparation": "Σύγκριτικά απότελέσματα ",
    "Confirm Password": "Επιβεβαίωση Κωδικού",
    "Confirmation": "Επιβεβαίωση",
    "Connection error!": "Σφάλμα σύνδεσης!",
    "Copied to clipboard": "Αντιγράφηκε στο πρόχειρο",
    "Copy": "Αντίγραφή",
    "Costumer Payments": "Πληρωμές πελατών",
    "Costumer Update": "Ενημέρωση πελατών",
    "Costumers": "Πελάτες",
    "Count": "Αρίθμηση",
    "Create": "Δημιουργία",
    "Create Allot Survey": "Δημιουργία Πρωτοτύπων ερωτηματολογίων",
    "Create Email": "Δημιουργία Email",
    "CREATE MAIL LIST": "ΔΗΜΙΟΥΡΓΙΑ ΛΙΣΤΑ EMAILS",
    "Create new emaillist": "Δημιουργία νέας λίστας email",
    "Create new survey": "Δημιουργία νέας έρευνας",
    "Create Personal Information (Sex/Age/Nationality)": "Δημιουργία προσωπικών στοιχείων (Φύλο/Ηλικία/Εθνικότητα)",
    "Create survey": "Δημιουργία έρευνας",
    "Create survey link": "Δημιουργία συνδέσμου έρευνας",
    "Create Survey Link, QR code": "Δημιουργήστε Link για το Ερωτηματολόγιο, QR code",
    "CSV": "CSV",
    "Current Password": "Τρέχων κωδικός πρόσβασης",
    "Custom Message": "Προσαρμοσμένο μήνυμα",
    "Daily": "Καθημερινά",
    "Dashboard": "Κεντρικός Πίνακας",
    "Date": "Ημερομηνία",
    "Deactive": "Ανενεργό",
    "Description": "Περιγραφή",
    "Description": "Περιγραφή",
    "Don't close application": "Μην κλείσετε την εφαρμογή",
    "Done successfully!": "Έγινε με επιτυχία!",
    "Download CSV": "Λήψη CSV",
    "Download Sync app here": "Κατεβάστε την Εφαρμογή Συγχρονισμού από εδώ",
    "E-mail List": "Λίστα ηλεκτρονικού ταχυδρομείου",
    "E-mail sender": "Αποστολέας e-mail",
    "E-mails": "E-mails",
    "ECC": "ECC",
    "Edit": "Επεξεργασία",
    "Edit Email": "Επεξεργασία email",
    "Edit question": "Επεξεργασία ερώτησης",
    "Edit survey": "Επεξεργασία έρευνας",
    "email": "email",
    "Email": "Email",
    "Email Account": "Λογαριασμός ηλεκτρονικού ταχυδρομείου",
    "Email address": "Λίστα email",
    "Email ID": "Email ID",
    "Email list": "Λίστες",
    "Email list not found": "Η λίστα email δεν βρέθηκε",
    "Email Name": "Όνομα Email",
    "Email or UserID": "Email ή Χρήστη",
    "Email Sender": "Αποστολέας email",
    "Email sending failed": "Η αποστολή email απέτυχε",
    "Email setting": "Ρυθμίσης email αποστολών",
    "Email Title": "Τίτλος Email",
    "Emails Group": "Ομάδα email",
    "Emails Group:": "Ομάδα email:",
    "Emojies + Flags at the Beginning": "Emojies + Σημαίες γλωσσών στην αρχή",
    "End Message": "Μήνυμα τέλους",
    "End Messages": "Μήνυμα τέλους",
    "Enter Answer Set name": "Εισαγάγετε Απάντηση Τοποθετήστε όνομα",
    "Enter E-mails (optional)": "Εισαγάγατε E-mails (προαιρετικά)",
    "Excel": "Excel",
    "Expire date": "Ημερομηνία Λήξης",
    "Expire Date": "Ημερομηνία Λήξης",
    "expired": "Λήξη",
    "Expired": "Έχει λήξει",
    "Export": "Εξαγωγή",
    "Female": "Θήλυ",
    "File not upload": "Το αρχείο δεν μεταφορτώνεται",
    "Filter": "Φίλτρο",
    "Filter options": "Επιλογές φίλτρου",
    "First name": "Όνομα",
    "First name": "Όνομα",
    "Free Field": "Ελεύθερο πεδίο",
    "Free ID": "Room number | Αριθμός Δωματίου | Zimmernummer",
    "Free Response": "Ελεύθερη απάντηση",
    "Free to Answer": "Ανοικτό για απάντηση χωρίς περιορισμούς",
    "From": "Από",
    "Get started": "Ας αρχίσουμε",
    "Groups": "Ομάδες",
    "Help": "Βοήθεια",
    "Home": "Αρχική",
    "How to use application": "Πως να χρησιμοποιήσετε την εφαρμογή",
    "Incorrect password": "Λάθος κωδικός",
    "Invalid email": "Μη έγκυρη διεύθυνση e-mail!",
    "Invalid email address!": "Μη έγκυρη διεύθυνση φιλοξενίας",
    "Invalid email format": "Μη έγκυρη μορφή email",
    "Invalid from or to value": "Μη έγκυρο αναγνωριστικό ή email",
    "Invalid hosting address": "Μη έγκυρη διεύθυνση φιλοξενίας",
    "Invalid id or email": "Μη έγκυρο email ή ID",
    "Invalid password format": "Μη έγκυρη μορφή κωδικού πρόσβασης",
    "Invalid port": "Μη έγκυρη θύρα",
    "Invalid smtp configuration": "Μη έγκυρη διαμόρφωση smtp",
    "Invalid survey": "Μη έγκυρο Ερωτημαοτολόγιο",
    "Invalid survey link": "Μη έγκυρος σύνδεσμος έρευνας",
    "Label": "Επιγραφή",
    "Language": "Γλώσσα",
    "Last name": "Επίθετο",
    "Length": "Μήκος",
    "List name": "Λίστα ονομάτων",
    "Loading": "Φόρτωση",
    "Log in": "Σύνδεση",
    "Login Page": "Σελίδα σύνδεσης",
    "Male": "Άρρεν",
    "Manual": "Χειροκίνητα",
    "Manual password": "Χειροκίνητος κωδικός πρόσβασης",
    "Message": "Μήνυμα",
    "Minimum Password length is 6": "Το ελάχιστο μήκος κωδικού πρόσβασης είναι 6",
    "Mongodb has error": "Το Mongodb παρουσίασε σφάλμα",
    "Months": "Μήνες",
    "N° of expired passwords": "Αριθμός ληγμένων κωδικών πρόσβασης",
    "N° of passwords": "Αριθμός κωδικών πρόσβασης",
    "N° of unused passwords": "Αριθμός αχρησιμοποίητων κωδικών πρόσβασης",
    "Name": "Όνομα",
    "name": "όνομα",
    "Name for Message to save": "Όνομα για το μήνυμα προς αποθήκευση",
    "New email added!": "Προστέθηκε νέο email!",
    "New Password": "Νέος κωδικός πρόσβασης",
    "NEW RESPONSE": "ΝΕΑ ΑΠΑΝΤΗΣΗ",
    "New Section": "Νέα Ενότητα",
    "Next": "Επόμενο",
    "No": "Όχι",
    "No Attempt": "Καμία προσπάθεια",
    "No data": "Χωρίς δεδομένα",
    "NO LIMITS": "ΧΩΡΙΣ ΟΡΙΑ",
    "No rows found": "Δεν βρέθηκαν σειρές",
    "No translatable option": "Δεν υπάρχει δυνατότητα μετάφρασης",
    "No. of Response": "Αριθμός ανταπόκρισης",
    "No. of Responses": "Αριθμός απαντήσεων",
    "Number of Passwords": "Αριθμός κωδικών πρόσβασης",
    "of": "του",
    "Old password is not correct": "Ο παλιός κωδικός πρόσβασης δεν είναι σωστός",
    "OPEN RESPONDENT'S SURVEY": "Άνοιγμα ερωτηματολογίου",
    "Other option": "Άλλη επιλογή",
    "Package Name": "Ονομα πακέτου",
    "Page": "Σελίδα",
    "Password": "Κωδικός πρόσβασης",
    "Password confirm mismatched": "Η επιβεβαίωση κωδικού πρόσβασης δεν ταιριάζει",
    "Password expired": "Ο κωδικός πρόσβασης έληξε",
    "Password Generator": "Αυτόματη δημιουργία Κωδικού",
    "Password length should be at least 6 letters": "Το μήκος του κωδικού πρόσβασης πρέπει να έχει τουλάχιστον 6 γράμματα",
    "Password not matched": "Ο κωδικός πρόσβασης δεν ταιριάζει",
    "Password should be at least 6 characters": "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 6 χαρακτήρες",
    "Password should be at least 6 letters": "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 6 γράμματα",
    "Password,Expire Date,Used": "Κωδικός πρόσβασης, Ημερομηνία Λήξης, Χρησιμοποιημένος",
    "Passwords": "Κωδικοί",
    "PASWORDS TO PROTECT YOUR SURVEYS": "ΚΩΔΙΚΟΙ ΓΙΑ ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΤΩΝ ΕΡΕΥΝΩΝ ΣΑΣ",
    "Pay Now": "Πληρώστε τώρα",
    "Payment Detail": "Λεπτομέρεια πληρωμής",
    "Payment details": "Οι λεπτομέρειες πληρωμής",
    "PDF": "PDF",
    "Period": "Περίοδο",
    "Period 1 Score:": "Βαθμολογία περιόδου 1:",
    "Period 2 Score:": "Βαθμολογία περιόδου 2:",
    "Period1:": "Περίοδος 1:",
    "Period2:": "Περίοδος 2:",
    "Period1": "Περίοδος 1",
    "Period2": "Περίοδος 2",
    "Personal Information": "Προσωπικές πληροφορίες",
    "Personalize the link": "Εξατομίκευση του συνδέσμου",
    "Personalized Link": "Εξατομικευμένος σύνδεσμος",
    "Please add options": "Προσθέστε επιλογές",
    "Please choose more options": "Επιλέξτε περισσότερες επιλογές",
    "Please choose number of selectable options": "Επιλέξτε τον αριθμό των επιλέξιμων επιλογών",
    "Please choose title": "Επιλέξτε τίτλο",
    "Please enter all field properly": "Παρακαλώ εισάγετε όλα τα πεδία σωστά",
    "Please enter campaign name": "Εισαγάγετε το όνομα της καμπάνιας",
    "Please enter email": "Εισαγάγετε email",
    "Please enter email list or emails": "Εισαγάγετε τη λίστα email ή emails",
    "Please enter email sender": "Παρακαλώ εισάγετε το email toy αποστολέα",
    "Please enter email subject": "Εισαγάγετε το θέμα του email",
    "Please enter language": "Παρακαλώ εισάγετε τη γλώσσα",
    "Please enter option label": "Εισαγάγετε την ετικέτα επιλογής",
    "Please enter password": "Παρακαλώ εισάγετε κωδικό πρόσβασης",
    "Please enter personalized link": "Εισαγάγετε τον εξατομικευμένο σύνδεσμο",
    "Please enter survey": "Παρακαλώ εισάγετε τo Ερωτηματολόγιο",
    "Please enter user name": "Εισαγάγετε το όνομα χρήστη",
    "Please input more than 3 check options": "Εισαγάγετε περισσότερες από 3 επιλογές ελέγχου",
    "Please insert question name": "Εισαγάγετε το όνομα της ερώτησης",
    "Please set count between 1~50": "Ρυθμίστε το πλήθος μεταξύ 1-50",
    "Please set length between 1~50": "Ορίστε το μήκος μεταξύ 1~50",
    "Please set positive Period": "Ορίστε θετική περίοδο",
    "Please set positive Price": "Ορίστε θετική τιμή",
    "Please set positive Response Limit": "Ορίστε όριο θετικής απόκρισης",
    "Please set title": "Ορίστε τον τίτλο",
    "Preview": "Προεπισκόπηση",
    "Previous": "Προηγούμενο",
    "Price": "Τιμή",
    "Price(€)": "Τιμή (€)",
    "Print": "Εκτύπωση",
    "Profile": "Προφίλ",
    "Protection With ID Password": "Προστασία του ερωτηματολογίου με κωδικό",
    "Purchase Date": "Ημερομηνία αγοράς",
    "Purchase Responds": "Η αγορά Απαντήσεων",
    "Purchased Response Plans": "Αγορασμένο πλάνο Απαντήσεων",
    "QR image": "QR",
    "Question": "Ερώτηση",
    "Question with Rating": "Ερώτηση με Βαθμολογία",
    "Random password": "Τυχαίος κωδικός πρόσβασης",
    "Register": "ΕΓΓΡΑΦΗ",
    "Register Page": "Σελίδα εγγραφής",
    "Relative": "Σχετικό",
    "Relative Answers": "Σχετικές Απαντήσεις",
    "Remove": "Αφαίρεση",
    "Remove": "Αφαίρεση",
    "Resend your survey to Not Attempt emails": "Στείλτε ξανά την έρευνά σας στα μηνύματα ηλεκτρονικού ταχυδρομείου που δεν απάντησαν",
    "Resonse Name": "Όνομα",
    "Respondent list": "Λίστα ερωτηθέντων",
    "Respondent Status": "Κατάσταση ερωτώμενου",
    "Response": "Απάντηση",
    "RESPONSE DETAILS": "ΣΤΟΙΧΕΙΑ ΑΠΑΝΤΗΣΗΣ",
    "Response Limit": "Όριο απαντήσεων",
    "Response Plan": "Πλάνο Απαντήσεων",
    "RESPONSE PLANS": "ΠΛΑΝΑ ΑΠΑΝΤΗΣΗΣ",
    "Responses": "Απαντήσεις",
    "Restart": "Επανεκκίνηση",
    "rows": "σειρές",
    "Save": "Αποθήκευση",
    "Save and add another": "Αποθηκεύστε και προσθέστε νέα ερώτηση",
    "Save Set": "Αποθήκευση όλης της ομάδας απαντήσεων",
    "Score": "Σκορ",
    "Score:": "Σκορ:",
    "Search by E-mail OR by ID OR password": "Αναζήτηση μέσω email ή με ID ή κωδικό πρόσβασης",
    "Section": "Ενότητα",
    "Section Average with Rating": "Μέσος όρος Ενότητας με Βαθμολογία",
    "Sections": "Ενότητες",
    "Select Saved Answers Group": "Επιλέξτε Ομάδα Αποθηκευμένων Απαντήσεων",
    "Select your Age": "Επιλέξτε την ηλικία σας",
    "Select your Nationality": "Επιλέξτε την εθνικότητα σας",
    "Select your Nationality": "Επιλέξτε την εθνικότητα σας",
    "Send campaign every day": "Καθημερινή Αποστολή",
    "Send campaign later": "Αποστολή καμπάνιας αργότερα",
    "Send campaign right now": "Αποστολή καμπάνιας τώρα",
    "Send date": "Ημερομηνία αποστολής",
    "Send Filter": "Αποστολή",
    "Send in Blue": "Αποστολή σε μπλε",
    "Send survey": "Αποστολή Ερωτηματολογίου",
    "SEND SURVEY LINK": "ΑΠΟΣΤΟΛΗ ΣΥΝΔΕΣΜΟΥ ΕΡΕΥΝΑΣ",
    "Send your survey": "Στείλτε την έρευνά σας",
    "Server error!": "Σφάλμα Διακομιστή!",
    "Size": "Μέγεθος",
    "Smtp host": "Smtp host",
    "Smtp port": "Θύρα Smtp",
    "SSL": "SSL",
    "Start date": "Ημερομηνία έναρξης",
    "Status": "Κατάσταση",
    "Subject": "Θέμα",
    "Successfully activated, you can use account now.": "Ενεργοποιήθηκε με επιτυχία, μπορείτε να χρησιμοποιήσετε τον λογαριασμό τώρα.",
    "Successfully added": "Προστέθηκε με επιτυχία",
    "Successfully copied to clipboard": "Αντιγράφηκε με επιτυχία στο πρόχειρο",
    "Successfully registered, please check your email to activate account.": "Η εγγραφή ολοκληρώθηκε με επιτυχία, ελέγξτε το email σας για να ενεργοποιήσετε τον λογαριασμό σας",
    "Successfully registered!": "Η εγγραφή έγινε με επιτυχία!",
    "Successfully saved": "Αποθηκεύτηκε με επιτυχία",
    "Successfully saved!": "Αποθηκεύτηκε με επιτυχία",
    "Successfully updated": "Ενημερώθηκε με επιτυχία",
    "Summary": "Περίληπτικά",
    "Survey": "Ερωτηματολόγιο",
    "survey": "Ερωτηματολόγιο",
    "SURVEY DETAILS": "ΣΤΟΙΧΕΙΑ ΕΡΕΥΝΑΣ",
    "SURVEY LINK": "ΣΥΝΔΕΣΜΟΣ ΕΡΩΤΗΜΑΤΟΛΟΓΙΟΥ",
    "Survey Name": "Όνομα έρευνας",
    "Survey passwords": "Κωδικοί πρόσβασης έρευνας",
    "Survey respondent": "Απαντημένα Ερωτηματολόγια",
    "Sync Email List": "Συγχρονισμός λίστας email",
    "Syncronize with local csv files": "Συγχρονισμός με τοπικά αρχεία csv",
    "Tax ID": "ΑΦΜ",
    "Tax Office": "ΔΟΥ",
    "Text reports": "Αναφορές με κείμενα",
    "There is no survey": "Δεν υπάρχει Ερωτηματολόγιο",
    "This ID will be used to sync local csv files with this email list": "Αυτό το αναγνωριστικό θα χρησιμοποιηθεί για τον συγχρονισμό τοπικών αρχείων csv με αυτήν τη λίστα email",
    "This password already used": "Αυτός ο κωδικός πρόσβασης χρησιμοποιείται ήδη",
    "This question is required": "Αυτή η ερώτηση είναι απαραίτητη",
    "This question is required?": "Αυτή η ερώτηση απαιτείται;",
    "Title": "Τίτλος",
    "title": "Τίτλος",
    "TLS": "TLS",
    "To": "Προς",
    "TOTAL ALLOWED ANSWERS": "ΣΥΝΟΛΟ ΕΠΙΤΡΕΠΟΜΕΝΩΝ ΑΠΑΝΤΗΣΕΩΝ",
    "Total E-mails": "Σύνολο ηλεκτρονικών μηνυμάτων",
    "Total Responses": "Συνολικές απαντήσεις",
    "Total Score:": "Συνολικό σκορ:",
    "TOTAL SURVEYS": "ΣΥΝΟΛΟ ΕΩΤΗΜΑΤΟΛΟΓΙΩΝ",
    "Translate": "Μεταφράσεις",
    "Translate survey": "Μετάφραση έρωτηματολογίου",
    "Type here": "Πληκτρολογίστε εδώ",
    "Undefined Error!": "Απροσδιόριστο σφάλμα!",
    "Unfortunately activation failed, please contact support team": "Δυστυχώς η ενεργοποίηση απέτυχε, επικοινωνήστε με την ομάδα υποστήριξης",
    "Unused": "Αχρησιμοποίητος",
    "Update": "Αναβάθμιση",
    "Update common": "Κοινή αναβάθμιση",
    "Update Password": "Ενημέρωση κωδικού πρόσβασης",
    "Update your info": "Ενημερώστε τις πληροφορίες σας",
    "Updated successfully": "Ενημερώθηκε με επιτυχία",
    "Upload CSV": "Μεταφόρτωση CSV",
    "Use status": "Κατάσταση Χρήσης",
    "Used": "Χρησιμοποιημένος",
    "User not found": "Ο χρήστης δεν βρέθηκε",
    "User with same email already exist!": "Χρήστης με το ίδιο email υπάρχει ήδη!",
    "User with same username already exist!": "Χρήστης με το ίδιο όνομα υπάρχει ήδη!",
    "Username": "Όνομα χρήστη",
    "Value": "Αξία",
    "View report": "Προβολή αναφοράς",
    "View reports": "Προβολή αναφορών",
    "What is your age range?": "Ποιο είναι το ηλικιακό σας εύρος;",
    "What is your gender?": "Ποιο είναι το φύλο σου;",
    "What is your Nationality?": "Ποια είναι η εθνικότητά σου?",
    "WINDOWS": "ΠΑΡΑΘΥΡΑ",
    "Write Your Question Here": "Γράψτε την ερώτησή σας εδώ",
    "Wrong email or password!": "Λάθος email ή κωδικός πρόσβασης!",
    "Yes": "ΝΑΙ",
    "You already have took this survey. Thanks": "Έχετε ήδη συμμετάσχει σε αυτήν την έρευνα. Ευχαριστούμε",
    "You can add emails in csv files in custom local directoy using gooSync application": "",
    "Your account is not activated": "Ο λογαριασμός σας δεν είναι ενεργοποιημένος",
    "Your Score": "Το σκορ σας",
    "Excellent": "Εξαιρετικά",
    "Very Good": "Πολύ καλά",
    "Good": "Καλά",
    "Fair": "Μέτρια",
    "Poor": "Ανεπαρκώς",
    "Per-location QR codes": "QR ανά σημείο",
    "Rooms / Tables / Locations": "Δωμάτια / Τραπέζια / Σημεία",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Δημιουργήστε ένα QR για κάθε σημείο (π.χ. δωμάτια 101–150 ή τραπέζια εστιατορίου). Κάθε QR μεταφέρει το σημείο του, ώστε οι απαντήσεις να χαρακτηρίζονται αυτόματα — ο επισκέπτης δεν το πληκτρολογεί ποτέ. Επιλέξτε πρώτα ερωτηματολόγιο και τύπο απάντησης παραπάνω.",
    "Add range": "Προσθήκη εύρους",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Επιπλέον σημεία (με κόμμα, π.χ. T1, T2, VIP)",
    "QR per page": "QR ανά σελίδα",
    "Label prefix (Room / Table / Σημείο)": "Πρόθεμα ετικέτας (Δωμάτιο / Τραπέζι / Σημείο)",
    "Caption (e.g. SCAN TO ANSWER)": "Λεζάντα (π.χ. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Τίτλος φύλλου (προεπιλογή: όνομα ερωτηματολογίου)",
    "Generate QR PDF": "Δημιουργία QR PDF",
    "locations": "σημεία",
    "Please choose a survey": "Επιλέξτε ερωτηματολόγιο",
    "No locations defined": "Δεν ορίστηκαν σημεία",
    "Too many locations (max 1000)": "Πάρα πολλά σημεία (μέγιστο 1000)",
    "Invalid range (from must be <= to)": "Μη έγκυρο εύρος (το «από» πρέπει να είναι ≤ «έως»)",
    "PDF generated": "Το PDF δημιουργήθηκε",
    "QR Code Sheet": "Φύλλο QR κωδικών",
    "Generated": "Δημιουργήθηκε",
    "Location": "Σημείο",
    "Location (room / table):": "Σημείο (δωμάτιο / τραπέζι):",
    "Exact / list (e.g. 205, 210)": "Ακριβές / λίστα (π.χ. 205, 210)",
    "Range from": "Εύρος από",
    "Range to": "Εύρος έως",
    "Guest": "Φιλοξενούμενος",
    "Location — exact / list (e.g. 205, 210)": "Σημείο — ακριβές / λίστα (π.χ. 205, 210)",
    "Location range from": "Εύρος σημείου από",
    "Location range to": "Εύρος σημείου έως",
    "is": "είναι",
    "is not": "δεν είναι",
    "includes": "περιλαμβάνει",
    "does not include": "δεν περιλαμβάνει",
    "between": "μεταξύ",
    "contains": "περιέχει",
    "does not contain": "δεν περιέχει",
    "on": "στις",
    "before": "πριν",
    "after": "μετά",
    "value": "τιμή",
    "min": "ελάχ.",
    "max": "μέγ.",
    "If answer": "Αν η απάντηση",
    "go to": "πήγαινε σε",
    "Next question (default)": "Επόμενη ερώτηση (προεπιλογή)",
    "Add rule": "Προσθήκη κανόνα",
    "Otherwise, go to": "Αλλιώς, πήγαινε σε",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Στείλε τον ερωτώμενο σε διαφορετική ερώτηση ανάλογα με την απάντησή του σε αυτή την ερώτηση. Οι κανόνες ελέγχονται από πάνω προς τα κάτω· ο πρώτος που ταιριάζει κερδίζει. Αν δεν ταιριάξει κανένας, ισχύει η προεπιλογή.",
    "Add this question's answer options first to build branching rules.": "Πρόσθεσε πρώτα τις επιλογές απάντησης αυτής της ερώτησης για να φτιάξεις κανόνες.",
    "Logic / Branching": "Λογική / Διακλάδωση",
    "optional": "προαιρετικό",
    "End of survey": "Τέλος ερωτηματολογίου",
    "A question with branching rules is answered before the survey continues.": "Μια ερώτηση με κανόνες διακλάδωσης απαντάται πριν συνεχίσει το ερωτηματολόγιο.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Συνολική βαθμολογία",
    "Positive": "Θετικές",
    "positive": "θετικές",
    "No answers": "Καμία απάντηση",

    // reports — Summary period comparison
    "Period 1": "Περίοδος 1",
    "Period 2": "Περίοδος 2",
    "Compare periods": "Σύγκριση περιόδων",
    "set Period 2": "ορίστε Περίοδο 2",

    "Anonymous response": "Ανώνυμη απάντηση",

    // reports — responses with no rating answered at all
    "No score": "Χωρίς βαθμολογία",
    "Hide responses with no score": "Απόκρυψη απαντήσεων χωρίς βαθμολογία",

    // reports — Text reports search/sort
    "No respondents match": "Καμία απάντηση δεν ταιριάζει με",
    "Search by location, name, email or answer text…": "Αναζήτηση ανά σημείο, όνομα, email ή κείμενο απάντησης…",
    "Sorted worst score first — the responses that need attention are at the top.": "Ταξινόμηση από τη χαμηλότερη βαθμολογία — οι απαντήσεις που θέλουν προσοχή είναι στην κορυφή.",

    // campaign SMS channel
    "Send via": "Αποστολή μέσω",
    "Both": "Και τα δύο",
    "SMS text": "Κείμενο SMS",
    "e.g. Thank you for staying with us! Tell us how it was: {link}": "π.χ. Thank you for staying with us! Tell us how it was: {link}",
    "chars": "χαρακτήρες",
    "segment(s)": "τμήμα(τα)",
    "segment": "τμήμα",
    "Placeholders": "Μεταβλητές",
    "This message costs": "Αυτό το μήνυμα κοστίζει",
    "per recipient. Shorten it to fit one segment.": "ανά παραλήπτη. Συντομεύστε το ώστε να χωρά σε ένα τμήμα.",
    "Cost preview": "Προεπισκόπηση κόστους",
    "recipients with a phone": "παραλήπτες με τηλέφωνο",
    "credits needed": "μονάδες απαιτούνται",
    "you have": "διαθέτετε",
    "recipients have no usable phone and will be skipped.": "παραλήπτες δεν έχουν έγκυρο τηλέφωνο και θα παραλειφθούν.",
    "Not enough credits — only part of the list will be sent.": "Δεν επαρκούν οι μονάδες — θα σταλεί μόνο μέρος της λίστας.",
    "Per-campaign cap": "Όριο ανά καμπάνια",
    "Please enter the SMS text": "Παρακαλώ εισάγετε το κείμενο του SMS",
    "The SMS text must contain {link} — that is where the survey link goes.": "Το κείμενο SMS πρέπει να περιέχει {link} — εκεί μπαίνει ο σύνδεσμος του ερωτηματολογίου.",

    // SMS delivery log
    "Delivery log": "Αρχείο παραδόσεων",
    "Refresh": "Ανανέωση",
    "Delivered": "Παραδόθηκε",
    "Sent": "Στάλθηκε",
    "Queued": "Σε αναμονή",
    "Failed": "Απέτυχε",
    "Phone": "Τηλέφωνο",
    "You use your own provider account and are billed directly by them. Create an account and copy the credentials here:": "Χρησιμοποιείτε δικό σας λογαριασμό παρόχου και χρεώνεστε απευθείας από αυτόν. Δημιουργήστε λογαριασμό και αντιγράψτε εδώ τα στοιχεία:",
    "Create a Twilio account": "Δημιουργία λογαριασμού Twilio",
    "Create an Infobip account": "Δημιουργία λογαριασμού Infobip",
    "Twilio: Account SID and Auth Token are on the Console dashboard. The sender must be a number you bought, or a Messaging Service SID.": "Twilio: το Account SID και το Auth Token βρίσκονται στο Console. Ο αποστολέας πρέπει να είναι νούμερο που αγοράσατε ή Messaging Service SID.",
    "Infobip: the API key and your personal Base URL are on the API keys page of the dashboard.": "Infobip: το API key και το προσωπικό σας Base URL βρίσκονται στη σελίδα API keys του dashboard.",
    "Enter the endpoint and key of your operator.": "Δώστε το endpoint και το κλειδί του παρόχου σας.",

    // SMS channel settings
    "SMS": "SMS",
    "Send survey invitations by SMS as well as email. Messages are charged per segment by your provider.": "Αποστολή προσκλήσεων ερωτηματολογίου και με SMS, εκτός από email. Τα μηνύματα χρεώνονται ανά τμήμα (segment) από τον πάροχό σας.",
    "SMS credits": "Μονάδες SMS",
    "Max per campaign": "Μέγιστα ανά καμπάνια",
    "Provider": "Πάροχος",
    "Other (HTTP)": "Άλλος (HTTP)",
    "Account SID": "Account SID",
    "Auth Token": "Auth Token",
    "API secret (if required)": "API secret (αν απαιτείται)",
    "stored": "αποθηκευμένο",
    "Sender (number or Messaging Service SID)": "Αποστολέας (νούμερο ή Messaging Service SID)",
    "Sender ID": "Αναγνωριστικό αποστολέα",
    "Base URL (e.g. https://xxxxx.api.infobip.com)": "Base URL (π.χ. https://xxxxx.api.infobip.com)",
    "Endpoint URL": "Endpoint URL",
    "SMS sending enabled": "Ενεργή αποστολή SMS",
    "Send a test message": "Αποστολή δοκιμαστικού μηνύματος",
    "Uses one credit and goes through the same path as a campaign, so it proves the whole setup.": "Χρησιμοποιεί μία μονάδα και ακολουθεί την ίδια διαδρομή με μια καμπάνια, οπότε επιβεβαιώνει όλη τη ρύθμιση.",
    "Phone (e.g. +306912345678)": "Τηλέφωνο (π.χ. +306912345678)",
    "Send test": "Αποστολή δοκιμής",
    "Sending…": "Αποστολή…",
    "Test message sent": "Το δοκιμαστικό μήνυμα στάλθηκε",
    "Could not send": "Δεν ήταν δυνατή η αποστολή",
    "Enter a phone number in international format, e.g. +306912345678": "Δώστε τηλέφωνο σε διεθνή μορφή, π.χ. +306912345678",
    "A message containing Greek (or any non-Latin) characters fits only 70 characters per segment instead of 160 — the same text can cost twice as much. Keep invitations short and prefer English for international guests.": "Μήνυμα με ελληνικούς (ή άλλους μη λατινικούς) χαρακτήρες χωράει μόνο 70 χαρακτήρες ανά τμήμα αντί για 160 — το ίδιο κείμενο μπορεί να κοστίσει διπλάσια. Κρατήστε τις προσκλήσεις σύντομες και προτιμήστε αγγλικά για ξένους πελάτες.",

    // conditional sections/questions (show only if an earlier answer matches)
    "Show only if:": "Εμφάνιση μόνο αν:",
    "Show this question only if": "Εμφάνιση αυτής της ερώτησης μόνο αν",
    "Move up": "Μετακίνηση πάνω",
    "Move down": "Μετακίνηση κάτω",
    "Position": "Θέση",
    "OK": "OK",

    // question / section alerts (per-question notifications)
    "Question alerts": "Ειδοποιήσεις ανά ερώτηση",
    "Back to surveys": "Πίσω στα ερωτηματολόγια",
    "Notify a specific person when a single question — or a whole section — gets a bad answer, independently of the overall survey score.": "Ειδοποίηση συγκεκριμένου ατόμου όταν μια ερώτηση — ή ένας ολόκληρος τομέας — λάβει κακή απάντηση, ανεξάρτητα από τη συνολική βαθμολογία του ερωτηματολογίου.",
    "A specific question": "Συγκεκριμένη ερώτηση",
    "A whole section": "Ολόκληρος τομέας",
    "Whole section": "Ολόκληρος τομέας",
    "Notify when the answer is one of:": "Ειδοποίηση όταν η απάντηση είναι μία από:",
    "The alert fires if ANY rating question in this section gets one of the selected answers.": "Η ειδοποίηση ενεργοποιείται αν ΟΠΟΙΑΔΗΠΟΤΕ βαθμολογούμενη ερώτηση του τομέα λάβει μία από τις επιλεγμένες απαντήσεις.",
    "Recipient email": "Email παραλήπτη",
    "Department / label (optional)": "Τμήμα / ετικέτα (προαιρετικό)",
    "Message (optional)": "Μήνυμα (προαιρετικό)",
    "Configured alerts": "Ρυθμισμένες ειδοποιήσεις",
    "Scope": "Εμβέλεια",
    "Section / Question": "Τομέας / Ερώτηση",
    "Triggers on": "Ενεργοποίηση σε",
    "Department": "Τμήμα",
    // survey intro (mobile "read more" accordion)
    "Read more": "Διαβάστε περισσότερα",
    "Show less": "Λιγότερα",

    "Edit alert": "Επεξεργασία ειδοποίησης",
    "Cancel edit": "Ακύρωση επεξεργασίας",
    "Please choose a section": "Παρακαλώ επιλέξτε τομέα",
    "Please choose a question": "Παρακαλώ επιλέξτε ερώτηση",
    "Select at least one answer that triggers the alert": "Επιλέξτε τουλάχιστον μία απάντηση που ενεργοποιεί την ειδοποίηση",

    // reports — focused view (filter-selected section/question surfaced)
    "Focused view": "Εστιασμένη προβολή",
    "showing only your filtered selection": "εμφανίζεται μόνο η επιλογή των φίλτρων σας",
    "Email / Phone": "Email / Τηλέφωνο",
    "Search by phone": "Αναζήτηση με τηλέφωνο",
    "No SMS matches these filters.": "Κανένα SMS δεν ταιριάζει με αυτά τα φίλτρα.",
    "The name recipients see, 3 to 11 characters, letters and digits (e.g. AquilaHotel). Leave empty to use your provider account's default sender. Some countries require the name to be registered with the operator first — your provider will tell you.": "Το όνομα που βλέπουν οι παραλήπτες, 3 έως 11 χαρακτήρες, γράμματα και ψηφία (π.χ. AquilaHotels). Αφήστε το κενό για να χρησιμοποιηθεί ο προεπιλεγμένος αποστολέας του λογαριασμού σας. Σε ορισμένες χώρες το όνομα πρέπει να έχει καταχωρηθεί πρώτα στον πάροχο κινητής — θα σας ενημερώσει ο πάροχός σας.",
    "A sender name must be 3 to 11 characters, or most operators will reject it.": "Το όνομα αποστολέα πρέπει να έχει 3 έως 11 χαρακτήρες, αλλιώς θα απορριφθεί από τους περισσότερους παρόχους.",
    "Fire the alert when:": "Το alert ενεργοποιείται όταν:",
    "the answer is one of…": "η απάντηση είναι μία από…",
    "the score is below…": "η βαθμολογία είναι κάτω από…",
    "Score below which the alert fires": "Βαθμολογία κάτω από την οποία στέλνεται το alert",
    "Uses the average of the rating questions the guest answered in this section.": "Χρησιμοποιεί τον μέσο όρο των ερωτήσεων βαθμολογίας που απάντησε ο επισκέπτης σε αυτή την ενότητα.",
    "Uses the answer given to this question.": "Χρησιμοποιεί την απάντηση που δόθηκε σε αυτή την ερώτηση.",
    "Recipient email(s)": "Email παραληπτών",
    "Several addresses separated by commas — the whole department gets one email.": "Πολλές διευθύνσεις χωρισμένες με κόμμα — όλο το τμήμα λαμβάνει ένα email.",
    "Enter the score below which the alert fires": "Δώστε τη βαθμολογία κάτω από την οποία στέλνεται το alert",
    "Invalid email address": "Μη έγκυρη διεύθυνση email",
    "below {n}": "κάτω από {n}",
    "Recipients": "Παραλήπτες",
    "Channel": "Κανάλι",
    "Email + SMS": "Email + SMS",
    "EMAIL + SMS": "EMAIL + SMS",
    "Recipients with a phone": "Παραλήπτες με τηλέφωνο",
    "No SMS sent yet for this campaign.": "Δεν έχει σταλεί ακόμη SMS για αυτή την καμπάνια.",
    "Error": "Σφάλμα",
    "Loading…": "Φόρτωση…",
    "Click to copy, then paste where you want it to appear in the message:": "Πατήστε για αντιγραφή και επικολλήστε το εκεί που θέλετε να εμφανιστεί μέσα στο μήνυμα:",
    "Survey link": "Σύνδεσμος ερωτηματολογίου",
    "The link to the questionnaire. Required — without it the message has no purpose.": "Ο σύνδεσμος προς το ερωτηματολόγιο. Υποχρεωτικός — χωρίς αυτόν το μήνυμα δεν έχει νόημα.",
    "Guest name": "Όνομα πελάτη",
    "The name of the recipient, as stored in the phone list. Left empty when unknown.": "Το όνομα του παραλήπτη, όπως είναι καταχωρημένο στη λίστα τηλεφώνων. Μένει κενό αν δεν υπάρχει.",
    "Title (Mr / Mrs)": "Τίτλος (Κος / Κα)",
    "The title of the recipient, as stored in the phone list. Left empty when unknown.": "Ο τίτλος του παραλήπτη, όπως είναι καταχωρημένος στη λίστα τηλεφώνων. Μένει κενός αν δεν υπάρχει.",
    "Copied — paste it in the message": "Αντιγράφηκε — επικολλήστε το στο μήνυμα",
    "Added to the end of the message": "Προστέθηκε στο τέλος του μηνύματος",
    "SMS segment(s)": "τμήμα(τα) SMS",
    "credits": "μονάδες",
    "Billed by your own provider account.": "Η χρέωση γίνεται από τον δικό σας λογαριασμό παρόχου.",
    "Score from (e.g. 3.8)": "Βαθμολογία από (π.χ. 3.8)",
    "Score to (e.g. 5)": "Βαθμολογία έως (π.χ. 5)",
    "Export CSV": "Εξαγωγή CSV",
    "Export e-mails": "Εξαγωγή email",
    "Select all shown": "Επιλογή όλων όσων εμφανίζονται",
    "{n} selected": "{n} επιλεγμένα",
    "{n} shown — exports all of them unless you tick some": "{n} εμφανίζονται — εξάγονται όλα, εκτός αν επιλέξετε κάποια",
    "Nothing to export": "Δεν υπάρχει τίποτα για εξαγωγή",
    "No email addresses in the selected rows": "Δεν υπάρχουν διευθύνσεις email στις επιλεγμένες γραμμές",
    "Lists": "Λίστες",
    "Create list": "Δημιουργία λίστας",
    "Edit list": "Επεξεργασία λίστας",
    "Phone numbers": "Αριθμοί τηλεφώνου",
    "Add new phone in list": "Προσθήκη νέου τηλεφώνου στη λίστα",
    "Add phone to list": "Προσθήκη τηλεφώνου στη λίστα",
    "Add e-mail to list": "Προσθήκη email στη λίστα",
    "New phone added!": "Προστέθηκε νέο τηλέφωνο!",
    "Phone removed!": "Το τηλέφωνο αφαιρέθηκε!",
    "Email removed!": "Το email αφαιρέθηκε!",
    "That phone number is not valid. Write it with the country code, e.g. +306912345678.": "Ο αριθμός δεν είναι έγκυρος. Γράψτε τον με τον κωδικό χώρας, π.χ. +306912345678.",
    "That email address is not valid.": "Η διεύθυνση email δεν είναι έγκυρη.",
    "{added} added": "{added} προστέθηκαν",
    "Type": "Τύπος",
    "Create new phone list": "Νέα λίστα τηλεφώνων",
    "CREATE PHONE LIST": "ΔΗΜΙΟΥΡΓΙΑ ΛΙΣΤΑΣ ΤΗΛΕΦΩΝΩΝ",
    "Mobile phone": "Κινητό τηλέφωνο",
    "Location (room / table)": "Σημείο (δωμάτιο / τραπέζι)",
    "Columns, in this order": "Στήλες, με αυτή τη σειρά",
    "Only the number is required. Write it with the country code (+30…); numbers that cannot be dialled are skipped and reported.": "Μόνο ο αριθμός είναι υποχρεωτικός. Γράψτε τον με τον κωδικό χώρας (+30…)· αριθμοί που δεν καλούνται παραλείπονται και αναφέρονται.",
    "An optional 4th column is imported as the location (room / table).": "Μια προαιρετική 4η στήλη εισάγεται ως σημείο (δωμάτιο / τραπέζι).",
    "No phone numbers found": "Δεν βρέθηκαν αριθμοί τηλεφώνου",
    "{added} added, {skipped} skipped (unusable)": "{added} προστέθηκαν, {skipped} παραλείφθηκαν (μη έγκυρα)",
    "Please choose a phone list": "Επιλέξτε λίστα τηλεφώνων",
    "Phone List": "Λίστα τηλεφώνων",
    "No phone lists yet — create one under Email lists.": "Δεν υπάρχουν ακόμη λίστες τηλεφώνων — δημιουργήστε μία από τις Λίστες email.",
    "MOBILE CAMPAIGN": "ΚΑΜΠΑΝΙΑ ΚΙΝΗΤΟΥ",
    "Your filters exclude every response.": "Τα φίλτρα σας αποκλείουν όλες τις απαντήσεις.",
    "No response belongs to the selected group(s).": "Καμία απάντηση δεν ανήκει στις επιλεγμένες ομάδες.",
    "Answers from a QR / location link carry neither an email nor a phone, so a group can never match them.": "Οι απαντήσεις από QR / σύνδεσμο σημείου δεν έχουν ούτε email ούτε τηλέφωνο, οπότε δεν μπορούν ποτέ να ταιριάξουν με ομάδα.",
    "No response falls inside the selected period.": "Καμία απάντηση δεν βρίσκεται μέσα στην επιλεγμένη περίοδο.",
    "No response has the selected answer.": "Καμία απάντηση δεν έχει την επιλεγμένη τιμή.",
    "No response matches the selected location (room / table).": "Καμία απάντηση δεν ταιριάζει με το επιλεγμένο σημείο (δωμάτιο / τραπέζι).",
    "Survey has {n} response(s) in total.": "Το ερωτηματολόγιο έχει συνολικά {n} απαντήσεις.",
    "The selected group has no recipients, so the group filter was ignored.": "Η επιλεγμένη ομάδα δεν έχει παραλήπτες, οπότε το φίλτρο ομάδας αγνοήθηκε.",
    "Clear the section filter to see all sections.": "Καθαρίστε το φίλτρο ενότητας για να δείτε όλες τις ενότητες.",

    // reports — Excel export
    "Excel export is not available for this report": "Η εξαγωγή σε Excel δεν είναι διαθέσιμη για αυτό το report",

    // reports — AI summary
    "AI summary": "Σύνοψη AI",
    "Working well": "Τι λειτουργεί",
    "Needs attention": "Χρειάζεται προσοχή",
    "Trend vs previous period": "Τάση σε σχέση με την προηγούμενη περίοδο",
    "What guests are writing about": "Τι γράφουν οι επισκέπτες",
    "Recommended actions": "Προτεινόμενες ενέργειες",
    "Generated from aggregated ratings and anonymised comments for the selected period. Guest names and emails are redacted before analysis. AI summaries can contain mistakes — treat as a starting point, not a substitute for the underlying data.": "Παράχθηκε από συγκεντρωτικές βαθμολογίες και ανωνυμοποιημένα σχόλια για την επιλεγμένη περίοδο. Τα ονόματα και τα emails των επισκεπτών αποκρύπτονται πριν την ανάλυση. Οι συνόψεις AI μπορεί να περιέχουν λάθη — χρησιμοποίησέ τες ως αφετηρία, όχι ως υποκατάστατο των δεδομένων.",
    "Shown from your earlier summary for this period (no new generation used).": "Εμφανίζεται από την προηγούμενη σύνοψή σου για αυτή την περίοδο (δεν χρησιμοποιήθηκε νέα δημιουργία).",
    "Analysing…": "Ανάλυση…",
    "Regenerate": "Εκ νέου",
    "Generate summary": "Δημιουργία σύνοψης",
    "Pick a language, then generate a plain-language overview of the selected period — highlights, what needs attention, trend vs the previous period, and the themes guests raise. Grounded in the responses shown; guest names & emails are redacted before analysis.": "Διάλεξε γλώσσα και δημιούργησε μια σύνοψη σε απλή γλώσσα για την επιλεγμένη περίοδο — τι ξεχωρίζει, τι θέλει προσοχή, τάση σε σχέση με την προηγούμενη περίοδο και τα θέματα που θίγουν οι επισκέπτες. Βασισμένη στις απαντήσεις που εμφανίζονται· τα ονόματα και τα emails αποκρύπτονται πριν την ανάλυση.",
    "Included in your plan: 3 AI summaries per 24 hours.": "Περιλαμβάνονται στο πακέτο σου: 3 συνόψεις AI ανά 24 ώρες.",
    "Reading the responses and their comments…": "Ανάγνωση των απαντήσεων και των σχολίων…",
    "You have used all your AI summaries for today.": "Έχεις χρησιμοποιήσει όλες τις συνόψεις AI για σήμερα.",
    "Available again": "Διαθέσιμη ξανά",
    "AI is not configured yet.": "Το AI δεν έχει ρυθμιστεί ακόμα.",
    "AI error": "Σφάλμα AI",
    "AI summary is not available for this report": "Η σύνοψη AI δεν είναι διαθέσιμη για αυτό το report",
    "Compare with 2nd period (optional):": "Σύγκριση με 2η περίοδο (προαιρετικό):",
    "Choose a report type above to begin": "Διάλεξε τύπο report παραπάνω για να ξεκινήσεις",
    "Filters": "Φίλτρα",
    "Hide filters": "Απόκρυψη φίλτρων",
    "Show results": "Εμφάνιση αποτελεσμάτων",
    "Answer:": "Απάντηση:",
    "Choose a report type": "Επιλέξτε τύπο report",
    "Settings": "Ρυθμίσεις",
    "Google Review": "Κριτική Google",
    "Saved": "Αποθηκεύτηκε",
    "Could not save": "Δεν ήταν δυνατή η αποθήκευση",
    "Paste your Google Place ID (or the full Google review link) so guests can leave a review from the survey thank-you screen.": "Επικόλλησε το Google Place ID (ή ολόκληρο το link κριτικής της Google) ώστε οι επισκέπτες να μπορούν να αφήσουν κριτική από την οθόνη ευχαριστίας του ερωτηματολογίου.",
    "Preview review link": "Προεπισκόπηση link κριτικής",
    "Find your Place ID with the": "Βρες το Place ID σου με το",
    "Tip: the review link appears on the survey end screen for every guest who completes it.": "Συμβουλή: το link κριτικής εμφανίζεται στην τελική οθόνη σε κάθε επισκέπτη που ολοκληρώνει το ερωτηματολόγιο.",
    "Connect your Google Business Profile to import guest reviews into the reports and reply to them from here.": "Σύνδεσε το Google Business Profile για να εισάγεις τις κριτικές των επισκεπτών στα report και να απαντάς σε αυτές από εδώ.",
    "Coming soon — pending Google API access.": "Έρχεται σύντομα — εκκρεμεί η πρόσβαση στο Google API.",
    "Leave us a review on Google": "Αφήστε μας μια κριτική στη Google",
    "Thank you! Your feedback helps us improve.": "Ευχαριστούμε! Τα σχόλιά σας μας βοηθούν να βελτιωθούμε.",
    "Show the \"Leave a Google review\" button for this score range": "Εμφάνιση του κουμπιού «Αφήστε κριτική στη Google» για αυτό το εύρος βαθμολογίας",
    "Tip: enable the review button per score range in each survey's End Messages.": "Συμβουλή: ενεργοποίησε το κουμπί κριτικής ανά εύρος βαθμολογίας στα Μηνύματα Τέλους κάθε ερωτηματολογίου.",
    "Review links": "Σύνδεσμοι κριτικών",
    "Add your review links so guests can leave a review from the survey thank-you screen. Each platform with a link shows as a button.": "Πρόσθεσε τους συνδέσμους κριτικών ώστε οι επισκέπτες να αφήνουν κριτική από την οθόνη ευχαριστίας. Κάθε πλατφόρμα με σύνδεσμο εμφανίζεται ως κουμπί.",
    "TripAdvisor URL": "TripAdvisor URL",
    "Facebook URL": "Facebook URL",
    "Booking.com URL": "Booking.com URL",
    "Show the review buttons for this score range": "Εμφάνιση των κουμπιών κριτικής για αυτό το εύρος βαθμολογίας",
    "Review on": "Κριτική στο",
    "Tour": "Ξενάγηση",
    "Skip": "Παράλειψη",
    "Done": "Τέλος",
    "Summary cards": "Κάρτες σύνοψης",
    "The key numbers at a glance — overall score, responses and positive %. In compare mode they also show the change (Δ).": "Τα βασικά νούμερα με μια ματιά — συνολική βαθμολογία, απαντήσεις και % θετικών. Σε λειτουργία σύγκρισης δείχνουν και τη διαφορά (Δ).",
    "Pick a tab: Analytical, Summary, Text reports or AI summary. Nothing is selected until you choose one.": "Διάλεξε καρτέλα: Αναλυτικά, Περιληπτικά, Αναφορές με κείμενα ή Σύνοψη AI. Στην αρχή δεν είναι επιλεγμένο τίποτα.",
    "Choose the period": "Επιλέξτε την περίοδο",
    "Once you pick a type, set the date range you want to see here.": "Μόλις επιλέξεις τύπο, όρισε εδώ το χρονικό διάστημα που θέλεις να δεις.",
    "Open Filters to narrow by group, section, question, answer or location (room / table).": "Άνοιξε τα Φίλτρα για να περιορίσεις ανά ομάδα, ενότητα, ερώτηση, απάντηση ή σημείο (δωμάτιο / τραπέζι).",
    "Turn this on to reveal a second period and compare two date ranges side by side.": "Ενεργοποίησέ το για να εμφανιστεί δεύτερη περίοδος και να συγκρίνεις δύο διαστήματα δίπλα-δίπλα.",
    "Press this to render the report below with your chosen period and filters.": "Πάτησέ το για να εμφανιστεί το report παρακάτω, με την περίοδο και τα φίλτρα που διάλεξες.",
    "Export & Print": "Εξαγωγή & Εκτύπωση",
    "Print, PDF, Excel or CSV — each acts on whichever report you are currently viewing.": "Εκτύπωση, PDF, Excel ή CSV — το καθένα ενεργεί στο report που βλέπεις εκείνη τη στιγμή.",
    "without answer": "χωρίς απάντηση",
    "Saved summaries": "Αποθηκευμένες συνόψεις",
    "Every summary you generate is saved here automatically.": "Κάθε σύνοψη που δημιουργείς αποθηκεύεται εδώ αυτόματα.",
    "Open": "Άνοιγμα",
    "Saved summary from": "Αποθηκευμένη σύνοψη από",
    "Active surveys": "Ενεργά ερωτηματολόγια",
    "inactive": "ανενεργά",
    "Total responses": "Συνολικές απαντήσεις",
    "Responses this year": "Απαντήσεις φέτος",
    "Available answers": "Διαθέσιμες απαντήσεις",
    "Surveys": "Ερωτηματολόγια",
    "Campaigns": "Καμπάνιες",
    "Email Lists": "Λίστες Email",
    "Create Link / QR": "Δημιουργία Link / QR",
    "Email settings": "Ρυθμίσεις Email",
    "Responses per month": "Απαντήσεις ανά μήνα",
    "Last 12 months": "Τελευταίοι 12 μήνες",
    "All years": "Όλα τα έτη",
    "Responses per survey": "Απαντήσεις ανά ερωτηματολόγιο",
    "Latest responses": "Τελευταίες απαντήσεις",
    "No responses yet": "Καμία απάντηση ακόμα",
    "anonymous": "ανώνυμη",
    "Open report": "Άνοιγμα αναφοράς",
    "Account users": "Χρήστες λογαριασμού",
    "Reports & statistics only": "Μόνο αναφορές & στατιστικά",
    "Campaigns & lists only": "Μόνο καμπάνιες & λίστες",
    "Full access": "Πλήρης πρόσβαση",
    "Extra logins for your team, each limited to a purpose. They sign in at the normal login page with their own email and password.": "Επιπλέον χρήστες για την ομάδα σου, ο καθένας με συγκεκριμένο σκοπό. Συνδέονται στην κανονική σελίδα εισόδου με δικό τους email και κωδικό.",
    "Please enter a valid email address": "Δώσε μια έγκυρη διεύθυνση email",
    "Password must be at least 6 characters": "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    "This email is already in use": "Αυτό το email χρησιμοποιείται ήδη",
    "You have reached the limit of extra users": "Έφτασες το όριο των επιπλέον χρηστών",
    "User not found": "Ο χρήστης δεν βρέθηκε",
    "User created": "Ο χρήστης δημιουργήθηκε",
    "Role updated": "Ο ρόλος ενημερώθηκε",
    "Password updated": "Ο κωδικός ενημερώθηκε",
    "Delete this user?": "Διαγραφή αυτού του χρήστη;",
    "New password for": "Νέος κωδικός για",
    "Change password": "Αλλαγή κωδικού",
    "Add user": "Προσθήκη χρήστη",
    "Your user role does not allow this action.": "Ο ρόλος σου δεν επιτρέπει αυτή την ενέργεια.",
    "Participation": "Συμμετοχή",
    "Participation by location": "Συμμετοχή ανά σημείο",
    "Responses per day for each location, against the expected number of people.": "Απαντήσεις ανά ημέρα για κάθε σημείο, σε σχέση με τα αναμενόμενα άτομα.",
    "People": "Άτομα",
    "(no location)": "(χωρίς σημείο)",
    "No responses in the selected period.": "Καμία απάντηση στην επιλεγμένη περίοδο.",
    "Save targets": "Αποθήκευση στόχων",
    "Targets saved": "Οι στόχοι αποθηκεύτηκαν",
    "People = how many are expected to answer at each location. The percentage is Total / People.": "Άτομα = πόσοι αναμένεται να απαντήσουν σε κάθε σημείο. Το ποσοστό είναι Σύνολο / Άτομα.",
    "Showing the first {n} days of the selected period.": "Εμφανίζονται οι πρώτες {n} ημέρες της επιλεγμένης περιόδου.",
};